import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { AuthStatusService } from '../../services/auth-status.service';
import { ExpertService } from 'src/app/services/expert.service';
import { PartnerService } from 'src/app/services/partner.service';
import { Partner, PartnerPaymentMethods, PartnerPaymentStatus } from 'src/app/models/partner.schema';
import * as env from '../../../environments/environment';
import { WebPushNotificationService } from 'src/app/services/web-push-notification.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { SpinnerService } from './../../services/spinner.service';
import { TransactionsService } from 'src/app/services/transactions.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public buttonsClicked;
  public userLoggedIn: boolean;
  public groups: string[];
  public alertUnreadCounter: number;
  public user: any;
  public guestView: boolean = true;
  public smsCheck: any;
  public loggedInExpert: any;
  isTeamLeader: boolean = false;
  public loggedInPartner: Partner;
  publicKey: string;
  privateKey: string;
  isNotificationEnable: boolean = false;
  notifications: any[] = [];
  notificationCount: number;
  expertWalletAmount: number;
  deferredPrompt: any;
  infoModal: boolean = false;

  constructor(
    private authStatusService: AuthStatusService,
    private userService: UserService,
    private expertService: ExpertService,
    private partnerService: PartnerService,
    private webPushNotificationService: WebPushNotificationService,
    private commanUsesService: CommanUsesService,
    private spinnerService: SpinnerService,
    private transactionsService: TransactionsService,
    private router: Router,
  ) {
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
      this.publicKey = env.environment.publicKey;
      this.privateKey = env.environment.privateKey;
    }
    catch {
      this.groups = [];
    }
  }

  async ngOnInit() {

    this.webPushNotificationService.notifications$.subscribe(count => {
      this.notificationCount = count;
    });

    this.expertService.expertWalletAmount$.subscribe(amount => {
      this.expertWalletAmount = amount;
    });

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'NEW_NOTIFICATION') {
        console.log('NEW_NOTIFICATION_RECEIVED')
        console.log("event.data.count", event.data.count)
        this.webPushNotificationService.updateNotificationCount(event.data.count);
      }
    });

    // this.userService.sendUserIdToServiceWorker();

    this.guestView = !(await this.authStatusService.isAuthenticated());
    this.buttonsClicked = {
      notificationShade: false,
      userShade: false,
      adminShade: false
    };
    if (!this.guestView)
      this.user = await this.userService.getMyInformation();
      delete this.user.qontoAccessToken;
      delete this.user.qontoRefreshToken;
      sessionStorage.setItem("currentUser", JSON.stringify(this.user));
    if(this.user)
      this.smsCheck = this.user['partner']?.sendSms;

    const loggedInUserInfo = await this.authStatusService.getTokenInfo();
    if(this.groups.includes('expert') && loggedInUserInfo){
      this.loggedInExpert = await this.expertService.getOne(loggedInUserInfo['extraId']);
      this.isTeamLeader = this.loggedInExpert?.isTeamLeader;
      let creditAmount: number;
      let result: { amount: number } = await this.transactionsService.getCreditAmount(this.loggedInExpert.id);
      creditAmount = result.amount;
      this.expertService.updateExpertWalletAmount(creditAmount || 0);
    }
    if(this.groups.includes('partner') && loggedInUserInfo){
      this.loggedInPartner = await this.partnerService.getOne(loggedInUserInfo['extraId']);
      const partner = this.loggedInPartner;
      if (
        partner &&
        (
          (partner?.partnerPaymentMethod && partner?.partnerPaymentStatus === null) ||
          [PartnerPaymentStatus.blocked, PartnerPaymentStatus.inactive].includes(partner?.partnerPaymentStatus)
        )
      ) {
        this.infoModal = true;
      }
    }
    await this.checkForPushNotification();
    await this.getNotifications();
  }

  increaseCount() {
    console.log("HI")
    this.webPushNotificationService.updateNotificationCount(this.notificationCount + 1);
  }

  ngAfterViewInit() {
    $('header.main-bar a').click(this.closeNavIcon);
  }

  async getMyInformation() {
    try {
      return await this.userService.getMyInformation();
    } catch (error) {
      
    }
  }

  async getNotifications() {
    try {
      // let notification = await this.webPushNotificationService.getAllNotifications();
      let notification: {count: number} = await this.webPushNotificationService.getNotificationCount(this.user.id);
      this.notificationCount = notification.count;
      this.webPushNotificationService.updateNotificationCount(this.notificationCount);
    } catch (error) {
      
    }
  }

  /*
  async checkForPushNotification(){
    if(this.user) {
      this.isNotificationEnable = this.user.webPushNotifications.length;
    }
  }
  */

  async checkForPushNotification(){

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    // console.log("subscription", subscription)
    let endpoint: string;
    if(subscription) {
      endpoint = subscription.endpoint;
    }
    if (this.user) {
      if (this.user.webPushNotifications.length && endpoint) {
        this.isNotificationEnable = this.user.webPushNotifications.some((item) => {
          return item?.endpoint === endpoint;
        });
      } else {
        this.isNotificationEnable = false;
      }
    }

  }

  buttonClicked(id: string) {
    event.preventDefault();
    if (!this.buttonsClicked[id]) {
      Object.keys(this.buttonsClicked).forEach(key => {
        this.buttonsClicked[key] = false;
        if (key != id)
          $(`#${key}Dropdown`).hide('fast');
      });
    }
    this.buttonsClicked[id] = !this.buttonsClicked[id];
    $(`#${id}Dropdown`).toggle('fast');
  }

  navIconClicked() {
    $('#navIcon').toggleClass('open');
    $('.header-nav').slideToggle('fast');
  }

  closeNavIcon() {
    $('#navIcon').removeClass('open');
    $('.header-nav').slideUp('fast');
  }

  async requestPermission() {
    if (!confirm("Vuoi abilitare le notifiche push?"))
      return;
    if (this.isSafariIOS() && !this.isStandaloneMode()) {
      alert('To receive notifications on iOS, install this app:\nTap Share → "Add to Home Screen".');
      return;
    }
    // return
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      await this.subscribeUserToPush();
    } else {
      console.error('Notification permission denied.');
    }
  }

  async subscribeUserToPush() {
    try {
      this.spinnerService.show();
      const registration = await navigator.serviceWorker.ready;
  
      // Subscribe the user to push notifications
      const pushSubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(`${this.publicKey}`)
      });
  
      console.log('Push subscription:', pushSubscription);
  
      // Convert ArrayBuffer keys to Base64 strings
      const subscriptionWithUser = {
        endpoint: pushSubscription.endpoint,
        keys: {
          p256dh: this.arrayBufferToBase64(pushSubscription.getKey('p256dh')),  // Convert to base64
          auth: this.arrayBufferToBase64(pushSubscription.getKey('auth'))     // Convert to base64
        },
        user: this.user  // Add user object to the subscription data
      };
  
      console.log("subscriptionWithUser", subscriptionWithUser);  // This should now include base64-encoded keys
  
      // Send the subscription and user data to the backend
      await this.sendSubscriptionToBackend(subscriptionWithUser);
      this.user = await this.getMyInformation();
      await this.checkForPushNotification();
      this.spinnerService.hide();
    } catch (error) {
      console.log("subscribeUserToPush", error)
      this.commanUsesService.showSnackBar("Qualcosa è andato storto");
      this.spinnerService.hide();
    }
    // window.location.reload();
  }




  // async sendSubscriptionToBackend(subscription: PushSubscription) {
  async sendSubscriptionToBackend(subscription: any) {
    try {
      let result = await this.webPushNotificationService.saveSubscription(subscription);
      if(result.id) {
        this.commanUsesService.showSnackBar("Le notifiche push sono abilitate.");
      }
    } catch (error) { }
  }

  async removePushSubscription() {
    try {
      if (!confirm("Sei sicuro? La notifica push verrà disattivata.?"))
        return;

      this.spinnerService.show();

      if(this.user) {

        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
          const endpoint = subscription.endpoint;
          console.log('Push Subscription Endpoint:', endpoint)
          let promise = await this.webPushNotificationService.removeSubscription(String(this.user.id), endpoint);
          console.log("promise", promise)
          if (promise?.result) {
            this.commanUsesService.showSnackBar("Le notifiche push sono disattivate.");
          } else {
            alert("Nessun abbonamento trovato per questo dispositivo o browser");
            await this.requestPermission();
          }
          this.user = await this.getMyInformation();
          await this.checkForPushNotification();
        } else {
          alert("Nessun abbonamento trovato per questo dispositivo o browser");
          await this.requestPermission();
        }
        this.spinnerService.hide();
      }
    } catch (error) {
      this.commanUsesService.showSnackBar("Qualcosa è andato storto");
      this.spinnerService.hide();
    }
  }

  urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')   // Replace URL-safe '+' with standard Base64 '+'
      .replace(/_/g, '/');   // Replace URL-safe '/' with standard Base64 '/'

    try {
      // Decode the base64 string into raw data
      const rawData = window.atob(base64); 

      // Create an array with the raw byte data
      const outputArray = new Uint8Array(rawData.length);

      // Convert each character to its corresponding byte
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }

      return outputArray;
    } catch (e) {
      console.error("Error in Base64 decoding: ", e);
      throw new Error('Invalid Base64 URL encoding.');
    }
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    try {
      const byteArray = new Uint8Array(buffer);
      let binary = '';
      for (let i = 0; i < byteArray.byteLength; i++) {
        binary += String.fromCharCode(byteArray[i]);
      }
      return window.btoa(binary);  // Convert to base64 string
    } catch (error) {
      console.log("arrayBufferToBase64", error);
    }
  }

  private isSafariIOS(): boolean {
    return (
      /iP(ad|hone|od)/.test(navigator.userAgent) &&
      /Safari/.test(navigator.userAgent) &&
      !/CriOS/.test(navigator.userAgent)
    );
  }

  private isStandaloneMode(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
  }

  closeInstallPopup() {
    this.infoModal = false;
  }

  logout() {
    const currentUrl = this.router.url;
    this.authStatusService.redirectUrl = currentUrl;
    this.authStatusService.logout();
    this.router.navigate(['/push/login']);
  }

}
